const personalInfoInputs = (defaults) => {
    return {
        name: {
            elementType: "text-field",
            elementConfig: {
                label: "نام",
                variant: "outlined",
                value: defaults?.name ?? "",
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 2,
            },
        },
        surname: {
            elementType: "text-field",
            elementConfig: {
                label: "نام خانوادگی",
                variant: "outlined",
                value: defaults?.surname ?? "",
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 2,
            },
        },
        birthday: {
            elementType: "date-picker",
            elementConfig: {
                label: "تاریخ تولد",
                variant: "outlined",
                value: defaults.birthday ?? "",
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 2,
            },
            value: defaults.birthday ?? "",
        },
        job: {
            elementType: "text-field",
            elementConfig: {
                label: "شغل",
                variant: "outlined",
                value: defaults.job ?? "",
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 2,
            },
        },
        sex: {
            elementType: "select-input",
            elementConfig: {
                label: "جنسیت",
                options: [
                    { label: "مرد", value: "MALE" },
                    { label: "زن", value: "FEMALE" },
                ],
                variant: "outlined",
                value: defaults.sex ?? "",
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 2,
            },
            value: defaults.sex ?? "MALE",
        },
        phone: {
            elementType: "text-field",
            elementConfig: {
                label: "شماره موبایل",
                variant: "outlined",
                value: defaults.phone ?? "",
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 2,
            },
        },
        address: {
            elementType: "text-field",
            elementConfig: {
                label: "آدرس",
                variant: "outlined",
                value: defaults.address ?? "",
                multiline: true,
                rows: 2,
            },
            gridConfig: {
                xs: 12,
                sm: 12,
                md: 12,
            },
        },
    };
};

export default personalInfoInputs;
